"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LanguageButton_1 = __importDefault(require("./LanguageButton"));
var react_intl_1 = require("react-intl");
var core_1 = require("@material-ui/core");
var react_router_dom_1 = require("react-router-dom");
var HomeIcon_1 = __importDefault(require("../assets/icon/HomeIcon"));
var ProductIcon_1 = __importDefault(require("../assets/icon/ProductIcon"));
var AboutIcon_1 = __importDefault(require("../assets/icon/AboutIcon"));
var MailIcon_1 = __importDefault(require("../assets/icon/MailIcon"));
var useRWD_1 = __importDefault(require("../use/useRWD"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Menu_1 = __importDefault(require("@material-ui/icons/Menu"));
var core_2 = require("@material-ui/core/");
var navList = [
    { to: "/#top", textId: "home", image: react_1.default.createElement(HomeIcon_1.default, null) },
    { to: "/productcenter#go-to-product-anchor", textId: "productCenter", image: react_1.default.createElement(ProductIcon_1.default, null) },
    { to: "/about", textId: "about", image: react_1.default.createElement(AboutIcon_1.default, null) },
    { to: "/contact", textId: "contact", image: react_1.default.createElement(MailIcon_1.default, { color: "primary" }) }
];
var StyledMenu = core_1.withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})(function (props) { return (react_1.default.createElement(core_1.Menu, __assign({ elevation: 0, getContentAnchorEl: null, anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
    }, transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    } }, props))); });
var StyledMenuItem = core_1.withStyles(function (theme) { return ({
    root: {
        '&:focus': {
            // backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}); })(core_1.MenuItem);
var HeaderLayout = function () {
    var device = useRWD_1.default();
    var _a = react_1.default.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    if (device === "PC") {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            navList.map(function (_a, index) {
                var to = _a.to, textId = _a.textId, image = _a.image;
                return (react_1.default.createElement(core_1.Button, { key: index, component: react_router_dom_1.Link, to: to, size: "large", color: "primary", startIcon: image },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: textId })));
            }),
            react_1.default.createElement(LanguageButton_1.default, null)));
    }
    else {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(LanguageButton_1.default, null),
            react_1.default.createElement(IconButton_1.default, { color: "primary", "aria-label": "menu", onClick: handleClick },
                react_1.default.createElement(Menu_1.default, null)),
            react_1.default.createElement(StyledMenu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleClose }, navList.map(function (_a, index) {
                var to = _a.to, textId = _a.textId, image = _a.image;
                return (react_1.default.createElement(core_2.Link, { key: index, component: react_router_dom_1.Link, underline: "none", to: to },
                    react_1.default.createElement(StyledMenuItem, null,
                        react_1.default.createElement(core_1.ListItemIcon, null, image),
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: textId }))));
            }))));
    }
};
exports.default = HeaderLayout;
